export default __webpack_public_path__ + "static/media/strategy_img_mobile.0dcc6799.svg";